<template>
    <td>
      <h6 class="custom-margin-h6-table">
        <strong>{{ $t('common_words.administrative_roles') }}:</strong>
      </h6>
      <span v-for="(_, valueKey) in managementRoles" :key="valueKey">
        <el-tag type="info" style="height: auto; width: 98%"
          >{{ $t('common_words.name') }}: {{ infoData.mgmtRolesSelected[valueKey] }}<br />
          {{ $t('common_words.associated_users2') }}:<br />
          <span v-for="(user, index) in infoData.mgmtRolesUsersSelected[valueKey].slice(0, 3)" :key="index">
          - {{ user }}<br />
        </span>
        </el-tag>
      </span>
    </td>
  </template>
  <script>
  export default {
    name: 'td-info-management-roles',
    props: {
      managementRoles: {
        required: true,
      },
      infoData: {
        type: Object,
        required: true,
      },
    },
  };
  </script>
  